import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'odq-card-tile',
    templateUrl: './card-tile.component.html',
    styleUrls: ['./card-tile.component.scss'],
    standalone: false
})
export class CardTileComponent implements OnInit {
  @Input() icon = 'local_mall';
  @Input() title = 'Title';
  @Input() subTitle = 'Sub Title Here';
  @Input() selected = false;

  @Output() tileClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  cardClicked($event) {
    this.tileClick.emit($event);
  }
}
